import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { FlavorType, VodkaType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { VodkaProperties } from '@app/api/models';

@Component({
  selector: 'app-vodka-properties-subform',
  templateUrl: './vodka-properties-subform.component.html',
  styleUrls: ['./vodka-properties-subform.component.scss'],
})
export class VodkaPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.VODKA_PROPERTIES';

  types = VodkaType;
  flavorType = FlavorType;

  get isFlavored(): boolean {
    return super.getCtrl('type')!.value === 'FLAVORED';
  }

  static buildForm(fb: FormBuilder, data?: VodkaProperties) {
    return fb.group({
      type: [data?.type, Validators.required],
      ...(data?.flavorTypes && {
        flavorTypes: [data?.flavorTypes, Validators.required],
      }),
    });
  }

  onTypeChange(type: VodkaType) {
    if (type === 'FLAVORED') {
      this.group.addControl(
        'flavorTypes',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.group.removeControl('flavorTypes');
    }
  }
}
